module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-panel-container chat-panel-container"
  }, [_c('div', {
    staticClass: "ibox chat-panel"
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_vm._m(0), _vm._v(" "), _c('h5', [_vm._v("Chat")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-tools"
  }, [(_vm.totalNotifications > 0) ? _c('el-dropdown', {
    on: {
      "command": _vm.handleTopicChange
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    }
  }, [_c('el-badge', {
    staticClass: "new-message",
    attrs: {
      "value": _vm.totalNotifications
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  })]), _vm._v(" "), (_vm.totalNotifications === 0) ? _c('i', {
    staticClass: "fa fa-bell"
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.notificationItems), function(notificationItem) {
    return _c('el-dropdown-item', {
      key: notificationItem.topic,
      attrs: {
        "command": notificationItem.topic
      }
    }, [_c('div', {
      staticClass: "notification-item"
    }, [_c('div', {
      staticClass: "notification-prepend"
    }, [_vm._v(_vm._s(notificationItem.prepend))]), _vm._v(" "), _c('div', {
      staticClass: "notification-name"
    }, [_vm._v(_vm._s(notificationItem.name))]), _vm._v(" "), _c('div', {
      staticClass: "notification-count"
    }, [_vm._v(_vm._s(notificationItem.count))])])])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "Close panel",
      "effect": "dark",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closePanel')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('channel-selector', {
    staticClass: "channel-selector",
    attrs: {
      "channels": _vm.channelsList,
      "notifications": _vm.notifications,
      "selected-topic": _vm.topic,
      "presences": _vm.presences
    },
    on: {
      "onSelectTopic": _vm.handleTopicChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chat-area"
  }, [_c('perfect-scrollbar', {
    ref: "content",
    staticClass: "chat-content",
    on: {
      "ps-scroll-y": _vm.handleScroll
    }
  }, [(_vm.channelError) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("Unable to join this converstaion")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.computedMessages), function(message) {
    return _c('div', {
      key: message.id
    }, [_c('div', {
      staticClass: "message",
      class: message.direction
    }, [(message.direction === 'in') ? _c('div', {
      staticClass: "name"
    }, [_vm._v("\n                " + _vm._s(message.user.first_name) + " " + _vm._s(message.user.last_name) + "\n              ")]) : _vm._e(), _vm._v(" "), (message.direction === 'out') ? _c('div', {
      staticClass: "name"
    }, [_vm._v("You")]) : _vm._e(), _vm._v("\n              " + _vm._s(message.body) + "\n              "), _c('div', {
      staticClass: "datetime"
    }, [_vm._v(_vm._s(_vm.displayDatetime(message.datetime)))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), _vm._v(" "), _c('div', {
    ref: "bottomScroll"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "chat-input"
  }, [_c('el-input', {
    on: {
      "focus": _vm.resetNotifications,
      "blur": _vm.resetNotifications
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submit($event)
      }
    },
    model: {
      value: (_vm.chatInput),
      callback: function($$v) {
        _vm.chatInput = $$v
      },
      expression: "chatInput"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "fa fa-arrow-up"
    },
    on: {
      "click": _vm.submit
    },
    slot: "append"
  })], 1)], 1)], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drag-indicator"
  }, [_c('i', {
    staticClass: "fa fa-reorder"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb4a5ac6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/chat/Chat.vue
// module id = 3419
// module chunks = 3